import React, { Component } from 'react';

export default class RiskProfileResult extends Component {

  constructor(props){
    super(props);
  }

  render(){
    return (
      <div>
        <div id="results-text">
          <h2 className="loading-animation text-left">Calculating your risk profile</h2>
        </div>
        <div className="stairs-loader">
          <div className="stairs-loader__bar"></div>
          <div className="stairs-loader__bar"></div>
          <div className="stairs-loader__bar"></div>
          <div className="stairs-loader__bar"></div>
          <div className="stairs-loader__bar"></div>
          <div className="stairs-loader__ball"></div>
        </div>
        <p>
          You will be able to edit your risk profile and see its
          effect on your retirement graph upon completing the onboarding
        </p>
      </div>
    );
  }
}
